"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyDocumentAdminDtoFileTypeEnum = exports.PropertyDocumentAdminDtoVisibilityEnum = void 0;
exports.instanceOfPropertyDocumentAdminDto = instanceOfPropertyDocumentAdminDto;
exports.PropertyDocumentAdminDtoFromJSON = PropertyDocumentAdminDtoFromJSON;
exports.PropertyDocumentAdminDtoFromJSONTyped = PropertyDocumentAdminDtoFromJSONTyped;
exports.PropertyDocumentAdminDtoToJSON = PropertyDocumentAdminDtoToJSON;
exports.PropertyDocumentAdminDtoToJSONTyped = PropertyDocumentAdminDtoToJSONTyped;
/**
 * @export
 */
exports.PropertyDocumentAdminDtoVisibilityEnum = {
    SystemOnly: 'system_only',
    Public: 'public',
    Private: 'private'
};
/**
 * @export
 */
exports.PropertyDocumentAdminDtoFileTypeEnum = {
    Pdf: 'pdf',
    Docx: 'docx',
    Doc: 'doc',
    Webp: 'webp',
    Png: 'png',
    Jpg: 'jpg',
    Jpeg: 'jpeg',
    Mp4: 'mp4',
    Webm: 'webm',
    Ogg: 'ogg',
    Mov: 'mov',
    Avi: 'avi',
    Mkv: 'mkv',
    M4v: 'm4v'
};
/**
 * Check if a given object implements the PropertyDocumentAdminDto interface.
 */
function instanceOfPropertyDocumentAdminDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isPublic' in value) || value['isPublic'] === undefined)
        return false;
    if (!('visibility' in value) || value['visibility'] === undefined)
        return false;
    if (!('fileType' in value) || value['fileType'] === undefined)
        return false;
    if (!('fileUrl' in value) || value['fileUrl'] === undefined)
        return false;
    return true;
}
function PropertyDocumentAdminDtoFromJSON(json) {
    return PropertyDocumentAdminDtoFromJSONTyped(json, false);
}
function PropertyDocumentAdminDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'isPublic': json['isPublic'],
        'visibility': json['visibility'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileType': json['fileType'],
        'fileUrl': json['fileUrl'],
        'altText': json['altText'] == null ? undefined : json['altText'],
    };
}
function PropertyDocumentAdminDtoToJSON(json) {
    return PropertyDocumentAdminDtoToJSONTyped(json, false);
}
function PropertyDocumentAdminDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'isPublic': value['isPublic'],
        'visibility': value['visibility'],
        'fileName': value['fileName'],
        'fileType': value['fileType'],
        'fileUrl': value['fileUrl'],
        'altText': value['altText'],
    };
}
